import React from 'react';

import { IProps } from './types';

import { Button, TextField } from '@material-ui/core';
import { customerUpdateAddressNickname } from '../AddressCard/__generated__/customerUpdateAddressNickname';
import { useLazyQuery, useMutation } from '@apollo/react-hooks';
import { CUSTOMER_UPDATE_ADDRESS_NICKNAME, DEFAULT_SHIPPING_ADDRESS } from '../AddressCard/queries';
import { useAlert } from 'react-alert';
import styled from 'styled-components';
import { defaultShippingAddress } from '../AddressCard/__generated__/defaultShippingAddress';
import { CUSTOMER_SET_DEFAULT_ADDRESS } from '@src/components/organisms/CheckoutInformation/queries';
import {
  ADDRESS_NICKNAME_REGEX,
  DISALLOWED_ADDRESS_NICKNAME_REGEX,
  DO_NOT_ALLOW_CONSECUTIVE_SPACE,
  ADDRESS_NICKNAME_REGEX_MAX_LENGTH,
} from '@src/utils/constants';

const AddressNicknameButton = styled.button`
  color: #ff3399;
  font-weight: bold;
`;

const CheckoutAddressWrapper = styled.div`
  padding: 2rem 2rem 2rem 2rem;
  margin-bottom: 1rem;
  border: 1px solid black;
`;

const CheckoutAddressStuff = styled.div`
  padding-bottom: 4px;
`;

const CheckoutAddressNicknameWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const CheckoutAddressNicknameButtonWrapper = styled.span``;

const CheckoutAddressItem: React.FC<IProps> = ({
  address,
  updateShippingAddress,
  refetch,
  defaultShippingAddress,
}: IProps) => {
  const alert = useAlert();
  const [addressNickname, setAddressNickname] = React.useState(address.addressNickname || '');
  const [open, setOpen] = React.useState(false);
  const [isActive, setIsActive] = React.useState(false);
  const [isDefaultAddress, setIsDefaultAddress] = React.useState(false);

  const handleButtonOn = () => {
    setIsActive(true);
  };

  const handleClickOpen = () => {
    setOpen(true);
    setIsActive(true);
  };

  const handleClose = () => {
    setOpen(false);
    setIsActive(false);
  };

  const [updateAddressNickname] = useMutation<customerUpdateAddressNickname>(CUSTOMER_UPDATE_ADDRESS_NICKNAME, {
    onCompleted: (data) => {
      if (!data.addressUpdate.errors.length) {
        alert.show('Success changed Address Nickname');

        window.location.reload();
      }
    },
  });

  const handleChangeAddressNickname = (value: string) => {
    let filteredValue = value.replace(DISALLOWED_ADDRESS_NICKNAME_REGEX, '');

    filteredValue = filteredValue.replace(DO_NOT_ALLOW_CONSECUTIVE_SPACE, ' ');

    if (filteredValue.length > ADDRESS_NICKNAME_REGEX_MAX_LENGTH) {
      filteredValue = filteredValue.slice(0, ADDRESS_NICKNAME_REGEX_MAX_LENGTH);
    }

    setAddressNickname(filteredValue);
  };

  const handleClickUpdateNickname = (event: React.MouseEvent<HTMLButtonElement>) => {
    const trimmedAddressNickname = addressNickname.trim();

    if (trimmedAddressNickname === '') {
      alert.show('Please enter a nickname.');
      return;
    }

    if (!ADDRESS_NICKNAME_REGEX.test(trimmedAddressNickname)) {
      alert.show("Alphabet, number and '-', '_' characters allowed");
      return;
    }

    updateAddressNickname({
      variables: {
        id: address.id,
        input: {
          country: 'IN',
          addressNickname: trimmedAddressNickname,
        },
      },
    });
  };

  const handleSelectDefaultAddress = (event: any) => {
    setIsDefaultAddress(true);
    updateShippingAddress(address.id);
  };

  return (
    (address && (
      <CheckoutAddressWrapper>
        {isActive == true ? (
          <CheckoutAddressNicknameWrapper>
            <TextField
              autoFocus
              margin="dense"
              id="addressNickname"
              label={address.addressNickname ? address.addressNickname : 'Enter new address Nickname'}
              type="text"
              value={addressNickname}
              onChange={(e) => handleChangeAddressNickname(e.target.value)}
              onClick={handleButtonOn}
            />
            <CheckoutAddressNicknameButtonWrapper>
              <Button onClick={handleClose} color="primary" variant="outlined" style={{ marginRight: 10 }}>
                Cancel
              </Button>
              <Button onClick={handleClickUpdateNickname} color="primary" variant="outlined">
                Change
              </Button>
            </CheckoutAddressNicknameButtonWrapper>
          </CheckoutAddressNicknameWrapper>
        ) : (
          <CheckoutAddressNicknameWrapper>
            <AddressNicknameButton onClick={handleClickOpen}>
              {address.addressNickname == ''
                ? 'Enter new address Nickname'
                : address.id != defaultShippingAddress.id
                ? address.addressNickname
                : '(Default address)' + ' ' + address.addressNickname}
            </AddressNicknameButton>
            {defaultShippingAddress.id == address.id ? (
              <></>
            ) : (
              <Button onClick={handleSelectDefaultAddress} color="secondary" variant="outlined">
                SELECT
              </Button>
            )}
          </CheckoutAddressNicknameWrapper>
        )}
        <CheckoutAddressStuff>
          {address.firstName} {address.lastName}
        </CheckoutAddressStuff>
        <CheckoutAddressStuff>{address.streetAddress1}</CheckoutAddressStuff>
        <CheckoutAddressStuff>{address.streetAddress2}</CheckoutAddressStuff>
        <CheckoutAddressStuff>{address.postalCode}</CheckoutAddressStuff>
        <CheckoutAddressStuff>{address.phone}</CheckoutAddressStuff>
      </CheckoutAddressWrapper>
    )) ||
    null
  );
};

export { CheckoutAddressItem };
